import { RouterService } from './router.service';

export default angular
  .module('sfMobile.services.router', ['ionic', 'ui.router'])
  .service('routerService', RouterService).name;
